import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

/** Unngår toast med teksten «undefined» når .message mangler (Firestore m.m.). */
export function toToastErrorMessage(input: unknown): string {
  if (input == null || input === '') {
    return 'Something went wrong. Please try again.';
  }
  if (typeof input === 'string') {
    const t = input.trim();
    return t || 'Something went wrong. Please try again.';
  }
  if (input instanceof Error) {
    const t = input.message?.trim();
    return t || input.name || 'Something went wrong. Please try again.';
  }
  const o = input as Record<string, unknown>;
  const msg = o['message'];
  if (typeof msg === 'string' && msg.trim()) {
    return msg.trim();
  }
  const code = o['code'];
  if (typeof code === 'string' && code.trim()) {
    return code.trim();
  }
  try {
    const s = JSON.stringify(input);
    if (s && s !== '{}') {
      return s.length > 220 ? `${s.slice(0, 220)}…` : s;
    }
  } catch {
    /* ignore */
  }
  return 'Something went wrong. Please try again.';
}

/** Alltid i konsoll/Logcat — filtrer på [ToastService] når toast forsvinner for fort. */
function logToastError(method: string, displayMessage: string, rawInput: unknown): void {
  console.error(`[ToastService.${method}] ${displayMessage}`);
  if (rawInput !== displayMessage && rawInput !== undefined && rawInput !== null && rawInput !== '') {
    console.error(`[ToastService.${method}] rå verdi:`, rawInput);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {


  constructor(public toastController: ToastController) { }



  async warning(warning: string, timer: number) {
    const toast = await this.toastController.create({
      message: warning,
      duration: timer,
      color: "warning"
    });
    toast.present();
  }
  async error(error: string | unknown) {
    const message = toToastErrorMessage(error);
    logToastError('error', message, error);
    const toast = await this.toastController.create({
      message,
      duration: 7000,
      color: "danger"
    });
    toast.present();
  }
  async errorWithTimer(error: string | unknown, timer: number) {
    const message = toToastErrorMessage(error);
    logToastError('errorWithTimer', message, error);
    const toast = await this.toastController.create({
      message,
      duration: timer,
      color: "danger"
    });
    toast.present();
  }
  async errorFromFirebaseWithTimer(error: any, timer: number) {

    const name = error?.name != null ? String(error.name) : 'Error';
    const code = error?.code != null ? String(error.code) : '';
    const errorString = code ? `${name}: ${code}` : name;

    logToastError('errorFromFirebaseWithTimer', errorString, error);
    const toast = await this.toastController.create({
      message: errorString,
      duration: timer,
      color: "danger"
    });
    toast.present();
  }



  async saveSuccess() {
    const toast = await this.toastController.create({
      message: 'Your data have been saved.',
      duration: 100,
      color: "success"
    });
    toast.present();
  }

  async toastSuccess(message: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      color: "success"
    });
    toast.present();
  }

  async toastSuccessTop(message: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
      position: "top",
      animated: true,
      color: "success"
    });
    toast.present();
  }

  async cheers() {
    const toast = await this.toastController.create({
      message: 'CHEERS!',
      duration: 200,
      color: "success",
      position: "top",
      animated: true


    });
    toast.present();
  }

  async automaticCheers() {
    const toast = await this.toastController.create({
      message: 'Tapping automatic!',
      duration: 200,
      color: "success",
      position: "top",
      animated: true


    });
    toast.present();
  }


  async cheersWithAmount(amount: string) {
    const toast = await this.toastController.create({
      message: 'CHEERS, ' + amount,
      duration: 1000,
      color: "success",
      position: "top",
      animated: true


    });
    toast.present();
  }

  async deleteItemSuccess() {
    const toast = await this.toastController.create({
      message: 'Deleted successfully.',
      duration: 500,
      color: "warning"
    });
    toast.present();
  }

}
